import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { ApproverUser } from 'types/backend';

export function useApproverUsers() {
    const http = useHttp();
    const { enqueueSnackbar } = useSnackbar();
    const { data, isFetching, isLoading } = useQuery<ApproverUser[], Error>(
        ['approverusers'],
        async () => {
            const { data } = await http.get(`api/approverUsers/GetApproverUsers`);

            return data || [];
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    );
    return { data, isFetching, isLoading } as const;
}
